// Tiny pub/sub so Timeline preview and TTSView pipelines (Generate All /
// Play All Favorites) can abort each other without threading callbacks
// through the component tree.
//
// TTSView registers `onCancelPipeline(fn)` and calls `fn()` to stop its
// in-flight pipeline. Timeline fires `requestCancelPipeline()` just before
// it starts preview playback. Conversely, TTSView fires
// `requestStopPreview()` when a pipeline starts, and the Timeline hook
// listens via `onStopPreview(fn)`.
//
// Parity with legacy: `playTimelinePreview()` called `cancelGenerateAll()`
// directly (index.html:7990). In React we keep the two features in
// separate trees — this module is the decoupling layer.

type Handler = () => void;

const cancelPipelineListeners = new Set<Handler>();
const stopPreviewListeners = new Set<Handler>();

/** TTSView registers its cancelPipeline() handler here. Returns a cleanup. */
export function onCancelPipeline(fn: Handler): () => void {
  cancelPipelineListeners.add(fn);
  return () => cancelPipelineListeners.delete(fn);
}

/** Timeline calls this to ask TTSView to abort any running pipeline. */
export function requestCancelPipeline(): void {
  for (const fn of cancelPipelineListeners) {
    try { fn(); } catch { /* ignore */ }
  }
}

/** Timeline registers its stop() handler here. */
export function onStopPreview(fn: Handler): () => void {
  stopPreviewListeners.add(fn);
  return () => stopPreviewListeners.delete(fn);
}

/** TTSView calls this before starting Generate-All / Play-All so any
 *  active preview is halted. */
export function requestStopPreview(): void {
  for (const fn of stopPreviewListeners) {
    try { fn(); } catch { /* ignore */ }
  }
}
